import * as PropTypes from 'prop-types';
import * as React from 'react';
import { deprecate } from '../../deprecate';

const HOVER_DELAY = 100; // ms
const UNHOVER_DELAY = 500; // ms

// Used to show a div on hover intent of some trigger component. This is similar to
// a tooltip. Because it adds a delay between mouseLeave and closing the panel, it
// allows for the mouse to travel to the panel and stay open, so that the user can
// click a link for example.
//
// triggerProps - Props that will be passed down to the <a> button.
// showOnce (optional, default false) - If true, it will open the panel on initial
// render, and once unhovered, will never show again. This is useful for eg success
// messages on clicking a button.
//
// <TooltipPanel>
//    <p>panel content</p>
// </Panel>
//

// Please don't use this for any future tooltip needs; use CSS-driven tooltips from commons
// It's exported for 1 use in core right now and will eventually be dprecated
export default class TooltipPanel extends React.Component {
  static get propTypes() {
    return {
      enabled: PropTypes.bool,
      triggerProps: PropTypes.object,
      showOnce: PropTypes.bool,
      children: PropTypes.node,
      isOpenInitially: PropTypes.bool,
      triggerOnHover: PropTypes.bool,
      align: PropTypes.oneOf(['left', 'right', 'center']),
      onOpen: PropTypes.func,
      onClose: PropTypes.func,
      className: PropTypes.string,
    };
  }

  static get defaultProps() {
    return {
      enabled: true,
      triggerOnHover: false,
      triggerProps: {},
      align: 'center',
      onOpen: () => {},
      onClose: () => {},
    };
  }

  constructor(props) {
    super(props);
    deprecate('TooltipPannel is deprecated, please use the CSS tooltips in commons');

    this.state = {
      isOpen: props.isOpenInitially || props.showOnce || false,
    };

    this.handleContainerClick = this.handleContainerClick.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.showPanel = this.showPanel.bind(this);
    this.hidePanel = this.hidePanel.bind(this);
    this.togglePanel = this.togglePanel.bind(this);
    this.mouseEnterCallback = null;
    this.mouseLeaveCallback = null;
  }

  componentDidMount() {
    document.addEventListener('click', this.hidePanel);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.hidePanel);
  }

  handleContainerClick(e) {
    if (e.nativeEvent.stopImmediatePropagation) {
      e.nativeEvent.stopImmediatePropagation();
    }
  }

  handleMouseEnter() {
    if (!this.props.triggerOnHover) { return; }
    this.clearTimeouts();
    if (this.props.showOnce) { return; }

    this.mouseEnterCallback = window.setTimeout(this.showPanel, HOVER_DELAY);
  }

  handleMouseLeave() {
    if (!this.props.triggerOnHover) { return; }
    this.clearTimeouts();
    this.mouseLeaveCallback = window.setTimeout(this.hidePanel, UNHOVER_DELAY);
  }

  clearTimeouts() {
    window.clearTimeout(this.mouseEnterCallback);
    window.clearTimeout(this.mouseLeaveCallback);
  }

  showPanel() {
    this.setState({ isOpen: true }, this.props.onOpen);
  }

  hidePanel() {
    this.setState({ isOpen: false }, this.props.onClose);
  }

  togglePanel(e) {
    e.preventDefault();

    if (this.state.isOpen) {
      this.hidePanel();
    } else {
      this.showPanel();
    }
  }

  renderPanel() {
    if (this.state.isOpen) {
      return (
        <div className="tooltip-panel__content">
          {this.props.children}
        </div>
      );
    }

    return null;
  }

  renderTrigger() {
    const props = { onClick: this.togglePanel,
      href: '#',
      ...this.props.triggerProps };

    return (
      <a {...props} />
    );
  }

  render() {
    if (!this.props.enabled) { return this.renderTrigger(); }

    return (
      <div
        className={`tooltip-panel tooltip-panel--align-${this.props.align} ${this.props.className}`}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onClick={this.handleContainerClick}
      >
        {this.renderTrigger()}
        {this.renderPanel()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/shared/tooltip_panel.jsx